import { createI18n } from 'vue-i18n';

import en from './languages/en-EN.json';
import de from './languages/de-DE.json';

const messages = {
  en: en,
  de: de,
};

const i18n = createI18n({
  locale: 'de',
  messages,
});

export default i18n;
